import React, { useState, PropsWithChildren } from "react";
import "./DropdownStyleExpanderStyles.scss";

import { Expander } from "components/generic/ExpandableSections/Expander";
import { DownTriangle } from "components/icons/DownTriangle";

type Props = {
    headerLabel: string;
};

export const DropdownStyleExpander: React.FC<PropsWithChildren<Props>> = (props: PropsWithChildren<Props>) => {
    const [isExpanded, setIsExpanded] = useState<boolean>(false);

    const headerComponent = (
        <div className="dropdown-expander-header">
            <div className="dropdown-expander-label">{props.headerLabel}</div>
            <div className="dropdown-expander-icon">
                <DownTriangle isActive={isExpanded} />
            </div>
        </div>
    );

    return (
        <Expander
            containerClassName="dropdown-expander-container"
            innerContainerClassName="dropdown-expander-body--inner"
            header={headerComponent}
            isExpandedState={{ isExpanded: isExpanded, setIsExpanded: setIsExpanded }}
        >
            {props.children}
        </Expander>
    );
};
